module.exports = __webpack_public_path__ + "static/teacher-student-167c2080d05c7edf3629057c2f5f2fd4.jpg";